import { appScope, panelTenant } from "@/lib/tenantPath";

const SLUG_KEY = "bf:biz_slug";
const NAME_KEY = "bf:biz_name";

/** A cookie survives the move to an installed iOS web app (the shortcut inherits the website state), so
 * the app can recover the business even when its own localStorage starts empty. */
function rememberCookie(slug, start, name) {
  const value = encodeURIComponent([slug, start || "public", name || ""].join("|"));
  document.cookie = `bf_biz=${value};path=/;max-age=31536000;samesite=lax`;
}

function setLink(rel, href) {
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.rel = rel;
    document.head.appendChild(el);
  }
  if (el.getAttribute("href") !== href) el.setAttribute("href", href);
}

function setMeta(name, content) {
  if (!content) return;
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

/** iOS ignores the manifest: the home-screen name, icon and status bar come from these meta tags. */
function applyIOS(base, version, name, themeColor) {
  setLink("apple-touch-icon", `${base}/icon-180.png?v=${version}`);
  setMeta("apple-mobile-web-app-capable", "yes");
  setMeta("mobile-web-app-capable", "yes");
  setMeta("apple-mobile-web-app-status-bar-style", "black-translucent");
  if (name) setMeta("apple-mobile-web-app-title", name);
  if (themeColor) setMeta("theme-color", themeColor);
}

export function applyBusinessManifest(slug, start, themeColor, version = "", name = "") {
  if (!slug) return;
  if (name) {
    localStorage.setItem(NAME_KEY, name);
    localStorage.setItem(`${NAME_KEY}:${slug}`, name); // lido pelo script inline do index.html (iOS)
  }
  localStorage.setItem(SLUG_KEY, slug);
  localStorage.setItem("bf:biz_start", start);
  rememberCookie(slug, start, name || localStorage.getItem(NAME_KEY) || "");
  // Relative (same-origin) on purpose: Safari only honours start_url/scope when the manifest comes from
  // the same origin as the page, otherwise the installed shortcut falls back to the site root.
  const base = `/api/public/businesses/${slug}`;
  setLink("manifest", `${base}/manifest.webmanifest?start=${start}&v=${version}`);
  setLink("icon", `${base}/icon-192.png?v=${version}`);
  const suffix = { admin: " Gestão", barber: " Equipa" }[start] || "";
  const bizName = name || localStorage.getItem(`${NAME_KEY}:${slug}`) || localStorage.getItem(NAME_KEY) || "";
  applyIOS(base, version, bizName ? `${bizName}${suffix}` : "", themeColor);
}

export function rememberBusiness(business, start) {
  if (!business?.slug) return;
  const label = business.short_name || business.name || "";
  localStorage.setItem(SLUG_KEY, business.slug);
  localStorage.setItem("bf:biz_start", start);
  localStorage.setItem(NAME_KEY, label);
  applyBusinessManifest(business.slug, start, business.brand_color, encodeURIComponent(business.logo_url || ""), label);
}

export function bootManifest() {
  const own = appScope();
  if (own) return applyBusinessManifest(own.slug, own.start, "", "");
  // legacy /admin or /barbeiro without the tenant path: remember the slug so the layout can redirect
  const fromUrl = new URLSearchParams(window.location.search).get("biz");
  if (fromUrl && !panelTenant()) localStorage.setItem(SLUG_KEY, fromUrl);
}

/** iOS versions that ignore the manifest keep the exact URL that was on screen when the page was added to
 * the home screen. "/b/slug" sits outside the app scope "/b/slug/", so normalise it before that happens. */
export function normalizeScopePath() {
  const own = appScope();
  const { pathname, search, hash } = window.location;
  if (own && pathname === own.scope.slice(0, -1)) {
    window.history.replaceState(null, "", `${own.scope}${search}${hash}`);
  }
}
